module.exports = {
    tidalTracking: require('./lib/tidalTracking'),
    tidalTrackingMiddleware: require('./middleware/tidalTracking.middleware'),
    pushToDataLayer: require('./lib/dataLayer'),
    tidalAmplitude: require('./lib/amplitude'),
};
